module.exports = __webpack_public_path__ + "static/media/grab-logo.b9d7828d.svg";